import { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowLeft, ArrowRight, Quote } from 'lucide-react';
import { TESTIMONIALS } from '../../data/site';

export const Testimonials = () => {
  const [index, setIndex] = useState(0);
  const t = TESTIMONIALS[index];

  return (
    <section data-testid="testimonials-section" className="py-24 lg:py-32 border-t border-clay">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <p className="text-[10px] tracking-[0.3em] text-terra font-medium mb-4">CHAPTER 04 — CLIENT VOICES</p>
          <h2 className="font-heading font-extrabold tracking-tighter text-4xl sm:text-5xl text-ink mb-10">Words that<br />shelter us</h2>
          <div className="flex gap-3">
            <button onClick={() => setIndex((index - 1 + TESTIMONIALS.length) % TESTIMONIALS.length)}
              data-testid="testimonial-prev-btn" aria-label="Previous testimonial"
              className="w-12 h-12 border border-clay flex items-center justify-center text-ink hover:bg-moss hover:text-sand hover:border-moss transition-colors duration-300">
              <ArrowLeft size={16} />
            </button>
            <button onClick={() => setIndex((index + 1) % TESTIMONIALS.length)}
              data-testid="testimonial-next-btn" aria-label="Next testimonial"
              className="w-12 h-12 border border-clay flex items-center justify-center text-ink hover:bg-moss hover:text-sand hover:border-moss transition-colors duration-300">
              <ArrowRight size={16} />
            </button>
            <span className="ml-4 self-center font-serif italic text-2xl text-ink/40" data-testid="testimonial-counter">
              0{index + 1} / 0{TESTIMONIALS.length}
            </span>
          </div>
        </div>

        <div className="lg:col-span-8 relative min-h-[280px]">
          <Quote size={40} className="text-terra/30 absolute -top-2 -left-1" />
          <AnimatePresence mode="wait">
            <motion.figure
              key={index}
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -16 }}
              transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
              className="pl-2 sm:pl-14"
              data-testid="testimonial-slide"
            >
              <blockquote className="font-serif italic text-2xl sm:text-3xl lg:text-4xl leading-snug text-ink">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-8 flex items-center gap-4">
                <img src={t.image} alt={t.name} className="w-12 h-12 object-cover grayscale" loading="lazy" />
                <div>
                  <p className="font-heading font-bold text-sm tracking-tight text-ink">{t.name}</p>
                  <p className="text-xs text-ink/50 mt-0.5">{t.role}</p>
                </div>
              </figcaption>
            </motion.figure>
          </AnimatePresence>
        </div>
      </div>
    </section>
  );
};
